// extracted by mini-css-extract-plugin
export default {"container":"DriverDetail_container__Jj-t6","closeButton":"DriverDetail_closeButton__EQ-Ge","iconLabel":"DriverDetail_iconLabel__QLe1t"};